import { render, staticRenderFns } from "./BarSettingsMinimalized.vue?vue&type=template&id=447776f4"
import script from "./BarSettingsMinimalized.vue?vue&type=script&lang=js"
export * from "./BarSettingsMinimalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports